import React, { FC } from "react"
import { CollaboratorStatus } from "../../../../../../../Models/API/CollaboratorModel"

export const LabelerUsernameWithStatus: FC<{
    username: string
    status?: CollaboratorStatus
}> = ({ username, status }) => {
    return (
        <>
            {username} (
            {status === CollaboratorStatus.DELETED
                ? "Deleted human worker"
                : status === CollaboratorStatus.INACTIVE
                ? "Inactive human worker"
                : "Human worker"}
            )
        </>
    )
}
